/**
 * Generate list of scripts
 * @param {array} urls
 * @return {element} div element with array of scripts
 */
export const generateElementsScript = urls => {
  return urls.reduce((div, url) => {
    const tag = document.createElement('script');
    tag.src = url;
    div.appendChild(tag);
    return div;
  }, document.createElement('div'));
};

/**
 * Function to append scripts in the end of body
 * @param {array} urls
 */
export const importExternalScripts = urls => {
  if (!Array.isArray(urls)) {
    return;
  }

  document
    .getElementsByTagName('body')[0]
    .appendChild(generateElementsScript(urls));
};
